module.exports = __webpack_public_path__ + "img/functionaltesting.cc460543.svg";